import type { TicketMessage } from '@/types/ticket'
import { formatDateTime } from '@/lib/dates'

// A centred pill in the secondary-button treatment: assignment and status
// events are context for the conversation around them, so they read as one
// quiet object between messages rather than as a third participant.
export function SystemMessageRow({ message }: { message: TicketMessage }) {
  return (
    <div className="my-3.5 text-center">
      <span
        className="inline-flex items-center gap-2 rounded-etn-pill bg-etn-control-subtle px-3 py-1 text-etn-micro text-etn-text-cell"
        data-testid="system-message"
      >
        <span>{message.body}</span>
        <span>{formatDateTime(message.createdAt)}</span>
      </span>
    </div>
  )
}
